/**
 * Skymedic UK - Cart Conversion Enhancements
 * ============================================
 * Injects into the Atelier cart drawer and cart page:
 * - Shipping info bar (free over £100, £4.99 below)
 * - Trust strip (secure checkout, free returns, certified)
 * - Quick upsell (best-sellers, 2 items max)
 */
(function () {
  'use strict';

  var SHIPPING_STANDARD_RATE = 499; /* £4.99 in pence — matches the UK delivery profile */
  var FREE_SHIPPING_THRESHOLD = 10000; /* £100 in pence (UK) */
  var UPSELL_COLLECTION = 'best-sellers';
  var MAX_UPSELL = 2;

  /* Locale-aware string helper */
  var SM_LOCALE = (function () {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('pt') === 0) return 'pt';
    if (lang.indexOf('fr') === 0) return 'fr';
    return 'en';
  })();
  function smT(strs) { return strs[SM_LOCALE] || strs.en; }
  var SM_CART_STRINGS = {
    shipping: smT({
      pt: 'Frete grátis acima de <strong>R$ 500</strong> — parcele em até 12x sem juros',
      fr: 'Livraison Maroc: <strong>30 DH + TVA</strong> sur toutes les commandes',
      en: 'UK delivery: <strong>FREE over £100</strong> — £4.99 below'
    }),
    free_shipping_progress: smT({
      pt: 'Faltam <strong>{{amount}}</strong> para FRETE GRÁTIS',
      fr: 'Plus que <strong>{{amount}}</strong> pour la LIVRAISON GRATUITE',
      en: 'Add <strong>{{amount}}</strong> for FREE UK delivery'
    }),
    free_shipping_unlocked: smT({
      pt: '🎉 Frete grátis! Pedido acima de R$ 500',
      fr: '🎉 Livraison gratuite! Commande au-dessus de 500 DH',
      en: '🎉 You\'ve unlocked <strong>FREE UK delivery!</strong>'
    }),
    secure_checkout: smT({ pt: 'Compra segura', fr: 'Paiement sécurisé', en: 'Secure checkout' }),
    returns: smT({ pt: 'Devolução em 7 dias', fr: 'Retours 14 jours', en: '14-day returns' }),
    cert: smT({ pt: 'ISO 22716 + 13485', fr: 'ISO 22716', en: 'ISO 22716' }),
    complete_routine: smT({
      pt: 'Complete sua rotina',
      fr: 'Complétez votre routine',
      en: 'Complete your routine'
    })
  };

  /* ===========================================================
   * 1. SHIPPING INFO BAR (free over £100, £4.99 below)
   * =========================================================== */

  function createShippingBar() {
    var el = document.createElement('div');
    el.className = 'sm-cart-shipping';
    el.id = 'SmCartShipping';
    el.innerHTML =
      '<div class="sm-cart-shipping__inner">' +
        '<svg class="sm-cart-shipping__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        '<span class="sm-cart-shipping__text" data-sm-ship-text></span>' +
      '</div>' +
      '<div class="sm-cart-shipping__bar"><div class="sm-cart-shipping__fill" data-sm-ship-fill></div></div>';
    return el;
  }

  function updateShippingBar(bar, totalPrice) {
    var textEl = bar.querySelector('[data-sm-ship-text]');
    var fillEl = bar.querySelector('[data-sm-ship-fill]');

    /* MA ships flat-rate — keep the static reassurance, no progress. */
    if (SM_LOCALE === 'fr') {
      textEl.innerHTML = SM_CART_STRINGS.shipping;
      bar.classList.add('sm-cart-shipping--complete');
      if (fillEl) fillEl.style.width = '100%';
      return;
    }

    /* UK (£100) & BR (R$ 500) — dynamic progress toward the free-delivery threshold. */
    var threshold = (SM_LOCALE === 'pt') ? 50000 /* R$ 500 in centavos */ : FREE_SHIPPING_THRESHOLD;
    var total = (typeof totalPrice === 'number') ? totalPrice : 0;
    if (total >= threshold) {
      textEl.innerHTML = SM_CART_STRINGS.free_shipping_unlocked;
      bar.classList.add('sm-cart-shipping--complete');
      if (fillEl) fillEl.style.width = '100%';
    } else {
      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var amountStr = (SM_LOCALE === 'pt')
        ? 'R$ ' + (remaining / 100).toFixed(2).replace('.', ',')
        : '£' + (remaining / 100).toFixed(2);
      textEl.innerHTML = SM_CART_STRINGS.free_shipping_progress.replace('{{amount}}', amountStr);
      bar.classList.remove('sm-cart-shipping--complete');
      if (fillEl) fillEl.style.width = pct + '%';
    }
  }

  /* ===========================================================
   * 2. TRUST STRIP
   * =========================================================== */

  function createTrustStrip() {
    var el = document.createElement('div');
    el.className = 'sm-cart-trust';
    el.id = 'SmCartTrust';
    el.innerHTML =
      '<div class="sm-cart-trust__item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>' +
        '<span>' + SM_CART_STRINGS.secure_checkout + '</span>' +
      '</div>' +
      '<div class="sm-cart-trust__item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>' +
        '<span>' + SM_CART_STRINGS.returns + '</span>' +
      '</div>' +
      '<div class="sm-cart-trust__item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
        '<span>' + SM_CART_STRINGS.cert + '</span>' +
      '</div>';
    return el;
  }

  /* ===========================================================
   * 3. QUICK UPSELL
   * =========================================================== */

  function createUpsellContainer() {
    var el = document.createElement('div');
    el.className = 'sm-cart-upsell';
    el.id = 'SmCartUpsell';
    el.innerHTML =
      '<p class="sm-cart-upsell__title">' + SM_CART_STRINGS.complete_routine + '</p>' +
      '<div class="sm-cart-upsell__items" data-sm-upsell-items></div>';
    return el;
  }

  function loadUpsellProducts(container, cartItemIds) {
    var itemsEl = container.querySelector('[data-sm-upsell-items]');

    fetch('/collections/' + UPSELL_COLLECTION + '/products.json?limit=10')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        if (!data || !data.products || data.products.length === 0) {
          container.style.display = 'none';
          return;
        }

        /* Filter out items already in cart */
        var available = data.products.filter(function (p) {
          var inCart = cartItemIds.some(function (id) { return id === p.id; });
          return !inCart && p.variants && p.variants.length > 0 && p.variants[0].available;
        });

        if (available.length === 0) {
          container.style.display = 'none';
          return;
        }

        var toShow = available.slice(0, MAX_UPSELL);
        var html = '';

        /* Detect store currency symbol + format. Locale-aware. */
        var SM_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
        var SM_CURRENCY_SYMBOL = { GBP: '\u00a3', BRL: 'R$ ', EUR: '\u20ac', USD: '$', MAD: 'DH ' }[SM_CURRENCY] || '';
        var SM_LOCALE_FMT = { pt: 'pt-BR', fr: 'fr-MA', en: 'en-GB' }[SM_LOCALE] || 'en-GB';
        function smFormatPrice(decimal) {
          var n = parseFloat(decimal);
          if (isNaN(n)) return '';
          try {
            return SM_CURRENCY_SYMBOL + n.toLocaleString(SM_LOCALE_FMT, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          } catch (_) {
            return SM_CURRENCY_SYMBOL + n.toFixed(2);
          }
        }

        toShow.forEach(function (p) {
          var v = p.variants[0];
          var img = p.images && p.images.length > 0 ? p.images[0].src : '';
          if (img) img = img.replace(/(\.\w+)(\?|$)/, '_120x$1$2');

          html +=
            '<div class="sm-cart-upsell__card">' +
              '<a href="/products/' + esc(p.handle) + '">' +
                (img ? '<img class="sm-cart-upsell__img" src="' + img + '" alt="" width="52" height="52" loading="lazy">' : '') +
              '</a>' +
              '<div class="sm-cart-upsell__info">' +
                '<p class="sm-cart-upsell__name">' + esc(p.title) + '</p>' +
                '<div class="sm-cart-upsell__price">' + smFormatPrice(v.price) + '</div>' +
              '</div>' +
              '<button class="sm-cart-upsell__add" data-sm-upsell-add="' + v.id + '" aria-label="Add ' + esc(p.title) + '">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M8 3v10M3 8h10"/></svg>' +
              '</button>' +
            '</div>';
        });

        itemsEl.innerHTML = html;

        /* Quick add buttons */
        itemsEl.querySelectorAll('[data-sm-upsell-add]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-sm-upsell-add');
            btn.disabled = true;

            /* Ask for the cart-items section HTML and fire the theme's own
               'cart:update' event so the open cart drawer re-renders its line
               items + total. Previously this only dispatched 'cart:updated'
               (note the trailing 'd') which the Horizon cart components do NOT
               listen to, so an upsell add left the drawer showing a stale total
               (e.g. bar said "FREE delivery unlocked" while the visible total
               still read the pre-add amount). */
            var upsellSectionIds = [];
            document.querySelectorAll('cart-items-component').forEach(function (el) {
              if (el.dataset && el.dataset.sectionId) upsellSectionIds.push(el.dataset.sectionId);
            });

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: parseInt(vid, 10), quantity: 1 }],
                sections: upsellSectionIds.join(','),
                sections_url: window.location.pathname
              })
            })
            .then(function (r) { return r.json(); })
            .then(function (added) {
              btn.classList.add('sm-cart-upsell__add--added');
              btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 7l3.5 3.5L12 3.5"/></svg>';
              return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  /* Theme event → cart-drawer / cart-items re-render. */
                  document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: 'sm-cart-upsell',
                      data: {
                        source: 'sm-cart-upsell',
                        itemCount: cart.item_count,
                        sections: added && added.sections
                      }
                    }
                  }));
                  /* Our own bars (drawer shipping bar + PDP meter + floating bar). */
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                });
            })
            .catch(function () {
              btn.disabled = false;
            });
          });
        });
      });
  }

  /* ===========================================================
   * INJECTION: Cart Drawer
   * =========================================================== */

  function enhanceCartDrawer() {
    /* Watch for the drawer dialog to open */
    var observer = new MutationObserver(function () {
      var dialog = document.querySelector('.cart-drawer__dialog[open]');
      if (!dialog) return;

      /* Don't inject twice */
      if (dialog.querySelector('#SmCartShipping')) return;

      /* Get cart data */
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || cart.item_count === 0) return;

          /* --- Shipping bar: insert after header --- */
          var header = dialog.querySelector('.cart-drawer__header');
          var content = dialog.querySelector('.cart-drawer__content');
          if (header && content) {
            var shipBar = createShippingBar();
            updateShippingBar(shipBar, cart.total_price);
            header.parentNode.insertBefore(shipBar, content);
          }

          /* --- Trust strip: insert before checkout button --- */
          var summary = dialog.querySelector('.cart-drawer__summary');
          if (summary) {
            var ctas = summary.querySelector('.cart__ctas');
            if (ctas) {
              var trust = createTrustStrip();
              ctas.parentNode.insertBefore(trust, ctas);
            }
          }

          /* --- Upsell: insert between items and summary --- */
          var items = dialog.querySelector('.cart-drawer__items');
          if (items && summary) {
            var upsell = createUpsellContainer();
            summary.parentNode.insertBefore(upsell, summary);
            var cartProductIds = cart.items.map(function (i) { return i.product_id; });
            loadUpsellProducts(upsell, cartProductIds);
          }
        });
    });

    observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }

  /* ===========================================================
   * INJECTION: Cart Page
   * =========================================================== */

  function enhanceCartPage() {
    if (window.location.pathname.indexOf('/cart') === -1) return;
    var cartSection = document.querySelector('.cart-totals');
    if (!cartSection) return;

    /* Already injected check */
    if (document.querySelector('#SmCartPageShipping')) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) return;

        /* Shipping bar at top of summary */
        var shipBar = createShippingBar();
        shipBar.id = 'SmCartPageShipping';
        shipBar.style.borderRadius = '8px';
        shipBar.style.marginBottom = '16px';
        updateShippingBar(shipBar, cart.total_price);

        var totalsContainer = document.querySelector('.cart-totals');
        if (totalsContainer) {
          totalsContainer.parentNode.insertBefore(shipBar, totalsContainer);
        }

        /* Trust strip before checkout */
        var ctas = document.querySelector('.cart__ctas');
        if (ctas) {
          var trust = createTrustStrip();
          trust.style.borderRadius = '8px';
          trust.style.marginBottom = '8px';
          ctas.parentNode.insertBefore(trust, ctas);
        }

        /* Keep the bottom reserve on .cart-items in sync with the real height
           of the sticky totals so the last line item is never hidden, no matter
           how tall the summary gets (expanded note/discount accordions,
           express-checkout buttons). Only relevant on the mobile sticky layout. */
        syncCartPageReserve();
      });
  }

  function syncCartPageReserve() {
    var mq = window.matchMedia('(max-width: 749px)');
    var items = document.querySelector('.template-cart .cart-items');
    var totals = document.querySelector('.template-cart .cart-totals');
    if (!items || !totals) return;

    var apply = function () {
      if (!mq.matches) {
        items.style.removeProperty('--sm-cart-reserve');
        return;
      }
      /* totals height + a small gap so the last row clears the shadow */
      var reserve = Math.ceil(totals.getBoundingClientRect().height) + 24;
      items.style.setProperty('--sm-cart-reserve', reserve + 'px');
    };

    apply();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(apply);
      ro.observe(totals);
    }
    /* matchMedia change + viewport resize (accordion toggles fire ResizeObserver) */
    if (mq.addEventListener) mq.addEventListener('change', apply);
    window.addEventListener('resize', apply, { passive: true });
  }

  /* ===========================================================
   * UPDATE ON CART CHANGES
   * =========================================================== */

  function setupCartUpdates() {
    document.addEventListener('cart:updated', function () {
      setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* Update all shipping bars */
            document.querySelectorAll('.sm-cart-shipping').forEach(function (bar) {
              updateShippingBar(bar, cart.total_price);
            });
          });
      }, 300);
    });

    /* Also listen for Shopify section rendering (Atelier updates cart via sections) */
    document.addEventListener('skymedic:cart:fetch', function () {
      setTimeout(function () {
        /* Re-inject if drawer was re-rendered */
        var dialog = document.querySelector('.cart-drawer__dialog[open]');
        if (dialog && !dialog.querySelector('#SmCartShipping')) {
          enhanceCartDrawer();
        }
      }, 500);
    });
  }

  /* ===========================================================
   * HELPERS
   * =========================================================== */

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  /* ===========================================================
   * INIT
   * =========================================================== */

  function init() {
    enhanceCartDrawer();
    enhanceCartPage();
    setupCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
